import {Box} from '@mui/material';
import React, {useCallback, useRef} from 'react';
import ReactPlayer from 'react-player';
import './ArrVideoPlayer.scss';

export interface ArrVideoPlayerProps {
  mediaUrl?: string;
  videoPlayerRef?: (ref: HTMLVideoElement | undefined) => void;
}

const ArrVideoPlayer: React.FC<ArrVideoPlayerProps> = ({
  mediaUrl,
  videoPlayerRef,
}: ArrVideoPlayerProps) => {
  const playerRef = useRef<HTMLVideoElement | undefined>(undefined);

  const setPlayerRef = useCallback(
    (player: HTMLVideoElement) => {
      if (!player) return;
      playerRef.current = player;
      videoPlayerRef?.(playerRef.current);
    },
    [videoPlayerRef]
  );

  return (
    <Box className="arr-video-player">
      <Box className={'arr-video-player-container'}>
        <ReactPlayer
          ref={setPlayerRef}
          className={'arr-video-player-element'}
          src={mediaUrl}
          controls
          disablePictureInPicture
          disableRemotePlayback
          controlsList={'nodownload'}
        />
      </Box>
    </Box>
  );
};

export default ArrVideoPlayer;
